import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkIsName } from "../../features/redux/authSlice";
import { renderImageStorage } from "../../util/imageRenderer";
import { Button, DateStorage } from "../../util/bloks";
import {
  getAllStorageFetch,
  setTableCheckTrueFetch,
} from "../../features/action/fetchStorage";
import StorageStatus from "./StorageStatus";
import { SHHeader } from "../common/SHHeader";
import Tables from "./Tables";
import { FaBoxes } from "react-icons/fa";
import { putUpdateKeeper } from "../../features/action/fetchKeeper";

const Storage = () => {
  const { storage, loadStorage } = useSelector((state) => state.storage);
  const dispatch = useDispatch();
  const [openTables, setOpenTables] = useState({});
  

  const toggleTable = (orderSH) => {
    setOpenTables((prev) => ({
      ...prev,
      [orderSH]: !prev[orderSH],
    }));
  };

  

  useEffect(() => {
    dispatch(getAllStorageFetch());
  }, [dispatch]);

  return (
    <div>
      <div className="flex flex-col w-full">
        <div className="flex flex-row w-[100%] my-2 text-center text-[#9E9E9E] text-base text-[1vw]">
          <div className=" text-[1.8vw]">SH Orders</div>
        </div>
        {/* Заголовки */}
        <SHHeader />
        {/* Список заказов */}
        {loadStorage &&
          storage.map((i, key) => (
            <div key={key}>
              <div
                className={`flex flex-row h-[70px] w-full mb-1 text-center rounded-[10px] bg-white border-solid border-2 border-[#dbdbdb]`}
                key={key}
              >
                {DateStorage(i.date)}
                {renderImageStorage(i.manager || "none")}
                <StorageStatus
                  status={i}
                  isOpen={openTables[i.tableSH]}
                  onToggle={() => toggleTable(i.tableSH)}
                />
              </div>
              {openTables[i.tableSH] && <Tables i={i} />}
             
            </div>
          ))}
      </div>
    </div>
  );
};

export default Storage;
